import common from "./common.json";
import creditEffect from "./creditEffect.json";

const EN = { common, creditEffect };
export default EN;
